/* eslint-disable */
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import { freeCancelingService } from '@/js/common/Domain/Service';

@propsDecorator({
	template: _.template(''),
	events: {
		'click .js-open-info-freeCancellation': 'openFreeCancellationPage'
	}
})
export default class FreeCancellationAbstract extends Backbone.Epoxy.View {
	initialize() {
		this.renderBanner();
	}

	openFreeCancellationPage(e) {
		freeCancelingService(e);
	}

	renderBanner() {
		this.$el.append(this.template());
	}
}
